var map = {
	"./Dragons.png": 4527,
	"./baronKills.png": 1264,
	"./damageDealtToTurrets.png": 4975,
	"./dragonKills.png": 5148,
	"./firstBloods.png": 7438,
	"./goldEarned.png": 4826,
	"./totalDamageDealtToChampions.png": 7845,
	"./totalDamageShieldedOnTeammates.png": 2991,
	"./totalDamageTaken.png": 8685,
	"./totalHealsOnTeammates.png": 9862,
	"./totalMinionsKilled.png": 5036,
	"./totalTimeCCDealt.png": 5031,
	"./visionScore.png": 1058,
	"./wardsKilled.png": 7175
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4973;